import React, { memo } from 'react';
import { NodeProps } from 'reactflow';
import { FilterNodeData } from '../../types/nodes';
import WhatsAppStyleNode from './WhatsAppStyleNode';

const ModernFilterNode = memo(({ data, selected }: NodeProps<FilterNodeData>) => {
  const getIcon = () => {
    const icons: Record<string, string> = {
      'user_type': '🎭',
      'message_type': '📝',
      'language': '🌐',
      'location': '🗺️',
      'group_membership': '🎪',
    };
    return icons[data.filterType] || '🔍';
  };

  const getLabel = () => {
    const labels: Record<string, string> = {
      'user_type': 'Tipo Utente',
      'message_type': 'Tipo Messaggio',
      'language': 'Lingua',
      'location': 'Posizione',
      'group_membership': 'Appartenenza Gruppo',
    };
    return labels[data.filterType] || data.label;
  };

  const getPreview = () => {
    const { config } = data;
    
    switch (data.filterType) {
      case 'user_type':
        const userTypeLabels: Record<string, string> = {
          'new': '🆕 Nuovo',
          'existing': '👤 Esistente',
          'vip': '⭐ VIP'
        };
        return config.userType ? userTypeLabels[config.userType] || config.userType : null;
      
      case 'message_type':
        const messageTypeLabels: Record<string, string> = {
          'text': '💬 Testo',
          'image': '🖼️ Immagine',
          'video': '🎥 Video',
          'audio': '🔊 Audio',
          'document': '📄 Documento'
        };
        return config.messageType ? messageTypeLabels[config.messageType] || config.messageType : null;
      
      case 'language':
        return config.language ? `🌐 ${config.language}` : null;
      
      case 'location':
        return config.country ? `📍 ${config.country}` : null;
      
      case 'group_membership':
        return config.groupIds?.length ? `${config.groupIds.length} gruppi` : null;
      
      default:
        return null;
    }
  };

  return (
    <WhatsAppStyleNode
      selected={selected}
      icon={getIcon()}
      label={getLabel()}
      preview={getPreview()}
      color="from-purple-500 to-pink-600"
      handles={{ source: true, target: true }}
    />
  );
});

ModernFilterNode.displayName = 'ModernFilterNode';

export default ModernFilterNode;
